/* eslint-disable no-undef */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'

function SEO({
  data,
  lang,
  title,
  ogTitle,
  ogDescription,
  description,
  keywords,
  metaTitle,
  pageTitle,
  articlePublisher,
  articlePublishedTime,
  articleModifiedTime,
  twitterCard,
  twitterCreator,
  twitterSite,
  ogImage,
  fromBlogView,
  ogImageWidth,
  ogImageHeight,
  twitterLabel1,
  twitterData1,
  twitterLabel2,
  twitterData2,
}) {
  const url = typeof window !== 'undefined' ? window.location.href : ''

  return (
    <>
      <title>{pageTitle}</title>
      <meta charset="utf-8" />
      <meta property="og:locale" content={lang} />
      <meta property="og:type" content="website" />
      {fromBlogView!==true && ogTitle ? (
        <meta property="og:title" content={get(data, `${lang}.${ogTitle}`)} />
      ) : null}
      {fromBlogView===true ? (
        <meta property="og:title" content={data.title} />
      ) : null}
      {fromBlogView===true ? (
        <meta property="og:description" content={ogDescription} />
      ) : null}
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="Sifars" />
      {articlePublisher ? (
        <meta property="article:publisher" content={articlePublisher} />
      ) : null}
      {articlePublishedTime ? (
        <meta property="article:published_time" content={articlePublishedTime} />
      ) : null}
      {articleModifiedTime ? (
        <meta property="article:modified_time" content={articleModifiedTime} />
      ) : null}
      {fromBlogView!==true ? (
      <meta property="og:image" content="/assets/sifars.png" />
      ) : null}
      {ogImage ? (
        <meta property="og:image" content={ogImage} />
      ) : null}
      {ogImageWidth ? (
        <meta property="og:image:width" content={ogImageWidth} />
      ) : null}
      {ogImageHeight ? (
        <meta property="og:image:height" content={ogImageHeight} />
      ) : null}
      {twitterCard ? (
        <meta name="twitter:card" content={twitterCard} />
      ) : null}
      {twitterCreator ? (
        <meta name="twitter:creator" content={twitterCreator} />
      ) : null}
      {twitterSite ? (
        <meta name="twitter:site" content={twitterSite} />
      ) : null}
      {twitterLabel1 ? (
        <meta name="twitter:label1" content={twitterLabel1} />
      ) : null}
      {twitterData1 ? (
        <meta name="twitter:data1" content={twitterData1} />
      ) : null}
      {twitterLabel2 ? (
        <meta name="twitter:label2" content={twitterLabel2} />
      ) : null}
      {twitterData2 ? (
        <meta name="twitter:data2" content={twitterData2} />
      ) : null}

      <meta name="robots" content="all" />
      <meta name="robots" content="noydir" />
      <meta name="robots" content="noodp" />
      <meta name="distribution" content="Global" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      {title ? (
        <meta name="title" content={get(data, `${lang}.${title}`)} />
      ) : null}

      {ogDescription ? (
        <meta
          property="og:description"
          content={get(data, `${lang}.${ogDescription}`)}
        />
      ) : null}

      {description ? (
        <meta
          name="description"
          content={get(data, `${lang}.${description}`)}
        />
      ) : null}
      {keywords ? (
        <meta name="keywords" content={get(data, `${lang}.${keywords}`)} />
      ) : null}

      {metaTitle ? (
        <meta name="title" content={get(data, `${lang}.${metaTitle}`)} />
      ) : null}
    </>
  )
}

SEO.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  lang: PropTypes.string.isRequired,
  title: PropTypes.string,
  ogTitle: PropTypes.string,
  ogDescription: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  metaTitle: PropTypes.string,
  pageTitle: PropTypes.string,
  articlePublisher: PropTypes.string,
  articlePublishedTime: PropTypes.string,
  articleModifiedTime: PropTypes.string,
  twitterCard: PropTypes.string,
  twitterCreator: PropTypes.string,
  twitterSite: PropTypes.string,
  ogImage: PropTypes.string,
  ogImageWidth: PropTypes.string,
  ogImageHeight: PropTypes.string,
  fromBlogView: PropTypes.bool,
  url: PropTypes.string.isRequired,
  twitterCreator: PropTypes.string,
  twitterLabel1: PropTypes.string,
  twitterData1: PropTypes.string,
  twitterLabel2: PropTypes.string,
  twitterData2: PropTypes.string,
}

SEO.defaultProps = {
  title: null,
  ogTitle: null,
  ogDescription: null,
  description: null,
  keywords: null,
  metaTitle: null,
  pageTitle: null,
  articlePublisher: null,
  articleModifiedTime: null,
  twitterCard: null,
  twitterCreator: null,
  twitterSite: null,
  ogImage: null,
  ogImageWidth: null,
  ogImageHeight: null,
  fromBlogView: false,
  articlePublishedTime: null,
  twitterCreator: null,
  twitterLabel1: null,
  twitterData1: null,
  twitterLabel2: null,
  twitterData2: null,
}

export default SEO
